<template>
  <a-config-provider :locale="locale">
    <div id="app">
      <router-view />
    </div>
  </a-config-provider>
</template>

<script>
  import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN';

  export default {
    data() {
      return {
        locale: zhCN,
      };
    },
    methods: {},
  };
</script>

<style lang="less">
  #app {
    font-family: apple-system, BlinkMacSystemFont, segoe ui, Roboto, helvetica neue, Arial, noto sans, sans-serif, apple color emoji, segoe ui emoji, segoe ui symbol, noto color emoji;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #09152D;
    width: 100%;
    height: 100%;
    font-size: 14px;
    font-weight: 400;
    min-width: 1440px;
  }
</style>
